export const ROUTES = {
  homepage: '/',
  overview: '/overview/$category',
  item: '/item/$movieID',
  missing: '/missing',
  request: '/request',
  search: '/search',
  random: '/random/$movieID',
}
